const axios = require('axios').default;
const instance = axios.create({
    baseURL: process.env.VUE_APP_SERVER_URL,
    timeout: 6000,
});
// Add a request interceptor
instance.interceptors.request.use(function (config) {
    const token = window.localStorage.getItem('ccToken');
    if (token) {
        config.headers.common['Authorization'] = `${token}`;
    }
    return config;
}, function (error) {
    return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(response => response, (e) => {
    const { response } = e;
    if (response == null) {
        return null
    }
    if ([401,403].includes(response.status)) {
        localStorage.removeItem('ccToken');
        localStorage.removeItem('ccEmail');
        localStorage.removeItem('ccSelectedSubItem');
        window.location.href = window.location.origin;
    } else {
        // return Promise.reject(response.data)
        return response.data
    }
});

export default instance